/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TrackRouteImport } from './routes/track'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as ProductionRouteImport } from './routes/production'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as ExpensesRouteImport } from './routes/expenses'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as CoaRouteImport } from './routes/coa'
import { Route as AccountingRouteImport } from './routes/accounting'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PaymentsIndexRouteImport } from './routes/payments/index'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as JournalsIndexRouteImport } from './routes/journals/index'
import { Route as ReportsProfitLossRouteImport } from './routes/reports/profit-loss'
import { Route as ReportsBalanceSheetRouteImport } from './routes/reports/balance-sheet'
import { Route as ReportsAgingReceivablesRouteImport } from './routes/reports/aging-receivables'
import { Route as OrdersNewRouteImport } from './routes/orders/new'
import { Route as OrdersIdRouteImport } from './routes/orders/$id'
import { Route as JournalsIdRouteImport } from './routes/journals/$id'
import { Route as CustomersNewRouteImport } from './routes/customers/new'
import { Route as CustomersIdRouteImport } from './routes/customers/$id'
import { Route as PaymentsNewOrderIdRouteImport } from './routes/payments/new.$orderId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackRoute = TrackRouteImport.update({
  id: '/track',
  path: '/track',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesRoute = ServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductionRoute = ProductionRouteImport.update({
  id: '/production',
  path: '/production',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesRoute = ExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const CoaRoute = CoaRouteImport.update({
  id: '/coa',
  path: '/coa',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingRoute = AccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsIndexRoute = PaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const JournalsIndexRoute = JournalsIndexRouteImport.update({
  id: '/journals/',
  path: '/journals/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsProfitLossRoute = ReportsProfitLossRouteImport.update({
  id: '/profit-loss',
  path: '/profit-loss',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsBalanceSheetRoute = ReportsBalanceSheetRouteImport.update({
  id: '/balance-sheet',
  path: '/balance-sheet',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsAgingReceivablesRoute = ReportsAgingReceivablesRouteImport.update({
  id: '/aging-receivables',
  path: '/aging-receivables',
  getParentRoute: () => ReportsRoute,
} as any)
const OrdersNewRoute = OrdersNewRouteImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIdRoute = OrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const JournalsIdRoute = JournalsIdRouteImport.update({
  id: '/journals/$id',
  path: '/journals/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersNewRoute = CustomersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => CustomersRoute,
} as any)
const CustomersIdRoute = CustomersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CustomersRoute,
} as any)
const PaymentsNewOrderIdRoute = PaymentsNewOrderIdRouteImport.update({
  id: '/payments/new/$orderId',
  path: '/payments/new/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRoute
  '/coa': typeof CoaRoute
  '/customers': typeof CustomersRouteWithChildren
  '/expenses': typeof ExpensesRoute
  '/inventory': typeof InventoryRoute
  '/login': typeof LoginRoute
  '/production': typeof ProductionRoute
  '/reports': typeof ReportsRouteWithChildren
  '/services': typeof ServicesRoute
  '/settings': typeof SettingsRoute
  '/track': typeof TrackRoute
  '/users': typeof UsersRoute
  '/customers/$id': typeof CustomersIdRoute
  '/customers/new': typeof CustomersNewRoute
  '/journals/$id': typeof JournalsIdRoute
  '/orders/$id': typeof OrdersIdRoute
  '/orders/new': typeof OrdersNewRoute
  '/reports/aging-receivables': typeof ReportsAgingReceivablesRoute
  '/reports/balance-sheet': typeof ReportsBalanceSheetRoute
  '/reports/profit-loss': typeof ReportsProfitLossRoute
  '/journals/': typeof JournalsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/payments/': typeof PaymentsIndexRoute
  '/payments/new/$orderId': typeof PaymentsNewOrderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRoute
  '/coa': typeof CoaRoute
  '/customers': typeof CustomersRouteWithChildren
  '/expenses': typeof ExpensesRoute
  '/inventory': typeof InventoryRoute
  '/login': typeof LoginRoute
  '/production': typeof ProductionRoute
  '/reports': typeof ReportsRouteWithChildren
  '/services': typeof ServicesRoute
  '/settings': typeof SettingsRoute
  '/track': typeof TrackRoute
  '/users': typeof UsersRoute
  '/customers/$id': typeof CustomersIdRoute
  '/customers/new': typeof CustomersNewRoute
  '/journals/$id': typeof JournalsIdRoute
  '/orders/$id': typeof OrdersIdRoute
  '/orders/new': typeof OrdersNewRoute
  '/reports/aging-receivables': typeof ReportsAgingReceivablesRoute
  '/reports/balance-sheet': typeof ReportsBalanceSheetRoute
  '/reports/profit-loss': typeof ReportsProfitLossRoute
  '/journals': typeof JournalsIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/payments': typeof PaymentsIndexRoute
  '/payments/new/$orderId': typeof PaymentsNewOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRoute
  '/coa': typeof CoaRoute
  '/customers': typeof CustomersRouteWithChildren
  '/expenses': typeof ExpensesRoute
  '/inventory': typeof InventoryRoute
  '/login': typeof LoginRoute
  '/production': typeof ProductionRoute
  '/reports': typeof ReportsRouteWithChildren
  '/services': typeof ServicesRoute
  '/settings': typeof SettingsRoute
  '/track': typeof TrackRoute
  '/users': typeof UsersRoute
  '/customers/$id': typeof CustomersIdRoute
  '/customers/new': typeof CustomersNewRoute
  '/journals/$id': typeof JournalsIdRoute
  '/orders/$id': typeof OrdersIdRoute
  '/orders/new': typeof OrdersNewRoute
  '/reports/aging-receivables': typeof ReportsAgingReceivablesRoute
  '/reports/balance-sheet': typeof ReportsBalanceSheetRoute
  '/reports/profit-loss': typeof ReportsProfitLossRoute
  '/journals/': typeof JournalsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/payments/': typeof PaymentsIndexRoute
  '/payments/new/$orderId': typeof PaymentsNewOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accounting'
    | '/coa'
    | '/customers'
    | '/expenses'
    | '/inventory'
    | '/login'
    | '/production'
    | '/reports'
    | '/services'
    | '/settings'
    | '/track'
    | '/users'
    | '/customers/$id'
    | '/customers/new'
    | '/journals/$id'
    | '/orders/$id'
    | '/orders/new'
    | '/reports/aging-receivables'
    | '/reports/balance-sheet'
    | '/reports/profit-loss'
    | '/journals/'
    | '/orders/'
    | '/payments/'
    | '/payments/new/$orderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accounting'
    | '/coa'
    | '/customers'
    | '/expenses'
    | '/inventory'
    | '/login'
    | '/production'
    | '/reports'
    | '/services'
    | '/settings'
    | '/track'
    | '/users'
    | '/customers/$id'
    | '/customers/new'
    | '/journals/$id'
    | '/orders/$id'
    | '/orders/new'
    | '/reports/aging-receivables'
    | '/reports/balance-sheet'
    | '/reports/profit-loss'
    | '/journals'
    | '/orders'
    | '/payments'
    | '/payments/new/$orderId'
  id:
    | '__root__'
    | '/'
    | '/accounting'
    | '/coa'
    | '/customers'
    | '/expenses'
    | '/inventory'
    | '/login'
    | '/production'
    | '/reports'
    | '/services'
    | '/settings'
    | '/track'
    | '/users'
    | '/customers/$id'
    | '/customers/new'
    | '/journals/$id'
    | '/orders/$id'
    | '/orders/new'
    | '/reports/aging-receivables'
    | '/reports/balance-sheet'
    | '/reports/profit-loss'
    | '/journals/'
    | '/orders/'
    | '/payments/'
    | '/payments/new/$orderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountingRoute: typeof AccountingRoute
  CoaRoute: typeof CoaRoute
  CustomersRoute: typeof CustomersRouteWithChildren
  ExpensesRoute: typeof ExpensesRoute
  InventoryRoute: typeof InventoryRoute
  LoginRoute: typeof LoginRoute
  ProductionRoute: typeof ProductionRoute
  ReportsRoute: typeof ReportsRouteWithChildren
  ServicesRoute: typeof ServicesRoute
  SettingsRoute: typeof SettingsRoute
  TrackRoute: typeof TrackRoute
  UsersRoute: typeof UsersRoute
  JournalsIdRoute: typeof JournalsIdRoute
  OrdersIdRoute: typeof OrdersIdRoute
  OrdersNewRoute: typeof OrdersNewRoute
  JournalsIndexRoute: typeof JournalsIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  PaymentsIndexRoute: typeof PaymentsIndexRoute
  PaymentsNewOrderIdRoute: typeof PaymentsNewOrderIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/track': {
      id: '/track'
      path: '/track'
      fullPath: '/track'
      preLoaderRoute: typeof TrackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services': {
      id: '/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof ServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/production': {
      id: '/production'
      path: '/production'
      fullPath: '/production'
      preLoaderRoute: typeof ProductionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses': {
      id: '/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof ExpensesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coa': {
      id: '/coa'
      path: '/coa'
      fullPath: '/coa'
      preLoaderRoute: typeof CoaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting': {
      id: '/accounting'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AccountingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/': {
      id: '/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof PaymentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journals/': {
      id: '/journals/'
      path: '/journals'
      fullPath: '/journals/'
      preLoaderRoute: typeof JournalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/profit-loss': {
      id: '/reports/profit-loss'
      path: '/profit-loss'
      fullPath: '/reports/profit-loss'
      preLoaderRoute: typeof ReportsProfitLossRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/balance-sheet': {
      id: '/reports/balance-sheet'
      path: '/balance-sheet'
      fullPath: '/reports/balance-sheet'
      preLoaderRoute: typeof ReportsBalanceSheetRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/aging-receivables': {
      id: '/reports/aging-receivables'
      path: '/aging-receivables'
      fullPath: '/reports/aging-receivables'
      preLoaderRoute: typeof ReportsAgingReceivablesRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/orders/new': {
      id: '/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof OrdersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$id': {
      id: '/orders/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof OrdersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journals/$id': {
      id: '/journals/$id'
      path: '/journals/$id'
      fullPath: '/journals/$id'
      preLoaderRoute: typeof JournalsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/new': {
      id: '/customers/new'
      path: '/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof CustomersNewRouteImport
      parentRoute: typeof CustomersRoute
    }
    '/customers/$id': {
      id: '/customers/$id'
      path: '/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof CustomersIdRouteImport
      parentRoute: typeof CustomersRoute
    }
    '/payments/new/$orderId': {
      id: '/payments/new/$orderId'
      path: '/payments/new/$orderId'
      fullPath: '/payments/new/$orderId'
      preLoaderRoute: typeof PaymentsNewOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface CustomersRouteChildren {
  CustomersIdRoute: typeof CustomersIdRoute
  CustomersNewRoute: typeof CustomersNewRoute
}

const CustomersRouteChildren: CustomersRouteChildren = {
  CustomersIdRoute: CustomersIdRoute,
  CustomersNewRoute: CustomersNewRoute,
}

const CustomersRouteWithChildren = CustomersRoute._addFileChildren(
  CustomersRouteChildren,
)

interface ReportsRouteChildren {
  ReportsAgingReceivablesRoute: typeof ReportsAgingReceivablesRoute
  ReportsBalanceSheetRoute: typeof ReportsBalanceSheetRoute
  ReportsProfitLossRoute: typeof ReportsProfitLossRoute
}

const ReportsRouteChildren: ReportsRouteChildren = {
  ReportsAgingReceivablesRoute: ReportsAgingReceivablesRoute,
  ReportsBalanceSheetRoute: ReportsBalanceSheetRoute,
  ReportsProfitLossRoute: ReportsProfitLossRoute,
}

const ReportsRouteWithChildren =
  ReportsRoute._addFileChildren(ReportsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountingRoute: AccountingRoute,
  CoaRoute: CoaRoute,
  CustomersRoute: CustomersRouteWithChildren,
  ExpensesRoute: ExpensesRoute,
  InventoryRoute: InventoryRoute,
  LoginRoute: LoginRoute,
  ProductionRoute: ProductionRoute,
  ReportsRoute: ReportsRouteWithChildren,
  ServicesRoute: ServicesRoute,
  SettingsRoute: SettingsRoute,
  TrackRoute: TrackRoute,
  UsersRoute: UsersRoute,
  JournalsIdRoute: JournalsIdRoute,
  OrdersIdRoute: OrdersIdRoute,
  OrdersNewRoute: OrdersNewRoute,
  JournalsIndexRoute: JournalsIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  PaymentsIndexRoute: PaymentsIndexRoute,
  PaymentsNewOrderIdRoute: PaymentsNewOrderIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
